import React, { useEffect, useState } from 'react';
import { related_routes_ticket_path } from 'js-routes/generated/routes';
import { number } from 'prop-types';
import RoutesList from './RoutesList';

const TicketRoutes = ({ ticketId = null }) => {
  const [ticketRoutes, setTicketRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoading(true);

    fetch(related_routes_ticket_path(ticketId))
      .then((response) => response.json())
      .then((data) => {
        setTicketRoutes(data.routes);
        setLoading(false);
      });
  }, [ticketId]);

  return (
    <>
      {ticketRoutes.length > 0 && <RoutesList routes={ticketRoutes} loading={loading} />}
    </>
  );
};

TicketRoutes.propTypes = {
  ticketId: number,
};

export default TicketRoutes;
